import { ILoadingAndFailure } from '../../types/interfaces'
import { ITelephoneSurveyActions, ITelephoneSurveyPayload, ITelephoneSurveysPayload } from './actions'
import { LOAD_SELECT_TELEPHONE_SURVEYS, LOAD_TELEPHONE_SURVEY } from './types'

export const initState = {
	telephoneSurveys: {
		originalData: [],
		tableData: [],
		pagination: null,
		isLoading: false,
		isFailure: false
	} as ITelephoneSurveysPayload & ILoadingAndFailure,
	detail: {
		data: null,
		isLoading: false,
		isFailure: false
	} as ITelephoneSurveyPayload & ILoadingAndFailure
}

export default (state = initState, action: ITelephoneSurveyActions) => {
	switch (action.type) {
		case LOAD_SELECT_TELEPHONE_SURVEYS.START:
			return {
				...state,
				telephoneSurveys: {
					...state.telephoneSurveys,
					isFailure: false,
					isLoading: true
				}
			}
		case LOAD_SELECT_TELEPHONE_SURVEYS.DONE:
			return {
				...state,
				telephoneSurveys: {
					...initState.telephoneSurveys,
					...action.payload
				}
			}
		case LOAD_SELECT_TELEPHONE_SURVEYS.FAILED:
			return {
				...state,
				telephoneSurveys: {
					...initState.telephoneSurveys,
					isFailure: true
				}
			}
		case LOAD_TELEPHONE_SURVEY.START:
			return {
				...state,
				detail: {
					...state.detail,
					isFailure: false,
					isLoading: true
				}
			}
		case LOAD_TELEPHONE_SURVEY.DONE:
			return {
				...state,
				detail: {
					data: action.payload.data,
					isFailure: false,
					isLoading: false
				}
			}
		case LOAD_TELEPHONE_SURVEY.FAILED:
			return {
				...state,
				detail: {
					...state.detail,
					isFailure: true,
					isLoading: false
				}
			}
		default:
			return state
	}
}
